import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, KeepAlive as _KeepAlive, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cfddb96"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-seo-page"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "custom-control custom-checkbox"
};
const _hoisted_5 = ["checked"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_error_occured = _resolveComponent("error-occured");
  const _component_seo_edit_item_new = _resolveComponent("seo-edit-item-new");
  const _component_app_table_head_seo = _resolveComponent("app-table-head-seo");
  const _component_seo_row = _resolveComponent("seo-row");
  const _component_seo_parent_row = _resolveComponent("seo-parent-row");
  const _component_seo_row_v2 = _resolveComponent("seo-row-v2");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_edit_text_modal = _resolveComponent("edit-text-modal");
  const _component_image_manager_modal = _resolveComponent("image-manager-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_error_occured, {
    onRetry: _ctx.refreshSellers
  }, null, 8, ["onRetry"])])) : _createCommentVNode("", true), !$data.errorOccured ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "container-seo-page-flex-child",
    ref: "seo-table-content",
    onScroll: _cache[12] || (_cache[12] = (...args) => $options.HidePopover && $options.HidePopover(...args)),
    onScrollend: _cache[13] || (_cache[13] = (...args) => $options.ShowPopover && $options.ShowPopover(...args))
  }, [$data.editSingleItem ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_seo_edit_item_new, {
    modelValue: $data.editSingleItem,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.editSingleItem = $event),
    onBack: $options.onEditSingleItemBack,
    onSubmit: _ctx.onSubmitSingleItem,
    content_id: $data.editContentId,
    content_amazon_link: $data.editContentLink
  }, null, 8, ["modelValue", "onBack", "onSubmit", "content_id", "content_amazon_link"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "custom-table-wrapper",
    ref: "seo-table",
    tabindex: "0",
    onMouseover: _cache[10] || (_cache[10] = (...args) => $options.keepFocus && $options.keepFocus(...args)),
    onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers((...args) => $options.keydownEscHandler && $options.keydownEscHandler(...args), ["prevent"]), ["esc"]))
  }, [_createVNode(_component_b_table_simple, {
    id: "content-table",
    class: "custom-table table-graph content-optimization-table-with-parent",
    "sticky-header": "",
    responsive: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_app_table_head_seo, {
      fields: $options.tableFields,
      "sort-by": $data.sortBy,
      "onUpdate:sortBy": _cache[2] || (_cache[2] = $event => $data.sortBy = $event),
      "sort-desc": $data.sortDesc,
      "onUpdate:sortDesc": _cache[3] || (_cache[3] = $event => $data.sortDesc = $event),
      onExpandImageList: $options.expandImageList,
      onCollapseImageList: $options.collapseImageList
    }, {
      select: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("input", {
        type: "checkbox",
        class: "custom-control-input",
        id: "selectAll",
        checked: $data.selectAll,
        onChange: _cache[1] || (_cache[1] = $event => $options.toggleSelectAll($event.target.checked))
      }, null, 40, _hoisted_5)])]),
      _: 1
    }, 8, ["fields", "sort-by", "sort-desc", "onExpandImageList", "onCollapseImageList"]), _ctx.products.length > 0 ? (_openBlock(), _createBlock(_component_b_tbody, {
      key: 0
    }, {
      default: _withCtx(() => [_ctx.pushModal ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList($options.filteredItems, (item, index) => {
        return _openBlock(), _createBlock(_component_seo_row, {
          item: item,
          key: item.content_id,
          index: index,
          selected_contents: _ctx.selected_contents,
          pushModal: _ctx.pushModal,
          push_loading: $options.isPushLoading(item.content_id),
          onOnEdit: params => $options.onEdit(params.item, params.type, params.title),
          isImageCellCollapsed: $data.isCollapsedImageList,
          onOnEditSingleItem: $options.onEditSingleItem,
          onOnConfirmPushSingleContent: _ctx.onConfirmPushSingleContent,
          onIsCopied: $options.isCopied,
          onOnCopyingHover: $options.onCopyingHover,
          onOnCopyingHoverLeave: $options.onCopyingHoverLeave,
          isCopying: $data.isCopying,
          onOnPaste: params => $options.onPaste(params.item, params.type, params.title),
          onExpandImageList: $options.expandImageList,
          onSelectItem: params => $options.selectItem(params.$event, params.item),
          showPopover: $data.showPopover,
          showCheckBox: false
        }, null, 8, ["item", "index", "selected_contents", "pushModal", "push_loading", "onOnEdit", "isImageCellCollapsed", "onOnEditSingleItem", "onOnConfirmPushSingleContent", "onIsCopied", "onOnCopyingHover", "onOnCopyingHoverLeave", "isCopying", "onOnPaste", "onExpandImageList", "onSelectItem", "showPopover"]);
      }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_ctx.parent_asin_to_child_asin_map, ([parent, children]) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [parent.is_parent_asin ? _withDirectives((_openBlock(), _createBlock(_component_seo_parent_row, {
          key: 0,
          parent: $options.transformParent(parent),
          collapsed: children.collapsed,
          onHandleToggle: $event => $options.handleToggle(parent)
        }, null, 8, ["parent", "collapsed", "onHandleToggle"])), [[_vShow, !children.collapsed || !$options.checkFilteredItemInChildren(children) || $options.checkFilteredItemParent(parent)]]) : _createCommentVNode("", true), (_openBlock(), _createBlock(_KeepAlive, null, [(!children.collapsed || $options.checkFilteredItemInChildren(children)) && parent.is_parent_asin ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList($options.getTableItemsForAsins(parent.parent_asin), (child_item, index) => {
          return _openBlock(), _createBlock(_component_seo_row_v2, {
            item: child_item,
            index: index,
            key: child_item.content_id,
            isLastItem: index == $options.getTableItemsForAsins(parent.parent_asin).length - 1,
            isFilteredChildren: $options.checkFilteredItemInChildren(children) && children.collapsed,
            selected_contents: _ctx.selected_contents,
            pushModal: _ctx.pushModal,
            push_loading: $options.isPushLoading(child_item.content_id),
            activatedFilteredItems: _ctx.products_filter.selectedItems,
            onShowParent: $event => $options.handleShowParent(children),
            onOnEdit: _cache[4] || (_cache[4] = params => $options.onEdit(params.item, params.type, params.title)),
            isImageCellCollapsed: $data.isCollapsedImageList,
            onOnEditSingleItem: $options.onEditSingleItem,
            onOnConfirmPushSingleContent: _ctx.onConfirmPushSingleContent,
            onIsCopied: $options.isCopied,
            onOnCopyingHover: $options.onCopyingHover,
            onOnCopyingHoverLeave: $options.onCopyingHoverLeave,
            isCopying: $data.isCopying,
            onOnPaste: _cache[5] || (_cache[5] = params => $options.onPaste(params.item, params.type, params.title)),
            onExpandImageList: $options.expandImageList,
            onSelectItem: _cache[6] || (_cache[6] = params => $options.selectItem(params.$event, params.select_item)),
            showPopover: $data.showPopover,
            showCheckBox: false
          }, null, 8, ["item", "index", "isLastItem", "isFilteredChildren", "selected_contents", "pushModal", "push_loading", "activatedFilteredItems", "onShowParent", "isImageCellCollapsed", "onOnEditSingleItem", "onOnConfirmPushSingleContent", "onIsCopied", "onOnCopyingHover", "onOnCopyingHoverLeave", "isCopying", "onExpandImageList", "showPopover"]);
        }), 128)) : _createCommentVNode("", true)], 1024)), !parent.is_parent_asin ? (_openBlock(), _createBlock(_component_seo_row, {
          item: parent,
          key: parent.content_id,
          selected_contents: _ctx.selected_contents,
          pushModal: _ctx.pushModal,
          push_loading: $options.isPushLoading(parent.content_id),
          onOnEdit: _cache[7] || (_cache[7] = params => $options.onEdit(params.item, params.type, params.title)),
          isImageCellCollapsed: $data.isCollapsedImageList,
          onOnEditSingleItem: $options.onEditSingleItem,
          onOnConfirmPushSingleContent: _ctx.onConfirmPushSingleContent,
          onIsCopied: $options.isCopied,
          onOnCopyingHover: $options.onCopyingHover,
          onOnCopyingHoverLeave: $options.onCopyingHoverLeave,
          isCopying: $data.isCopying,
          onOnPaste: _cache[8] || (_cache[8] = params => $options.onPaste(_ctx.param.item, params.type, params.title)),
          onExpandImageList: $options.expandImageList,
          onSelectItem: _cache[9] || (_cache[9] = params => $options.selectItem(params.$event, params.item)),
          showPopover: $data.showPopover,
          showCheckBox: false
        }, null, 8, ["item", "selected_contents", "pushModal", "push_loading", "isImageCellCollapsed", "onOnEditSingleItem", "onOnConfirmPushSingleContent", "onIsCopied", "onOnCopyingHover", "onOnCopyingHoverLeave", "isCopying", "onExpandImageList", "showPopover"])) : _createCommentVNode("", true)], 64);
      }), 256))]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })], 544)], 544)) : _createCommentVNode("", true), _createVNode(_component_app_modal, {
    modelValue: $data.confirmPushSingleContent,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.confirmPushSingleContent = $event),
    title: "Confirm Push Content",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[15] || (_cache[15] = $event => _ctx.onPushModalSubmit([$data.singleContentToPush.content_id]))
  }, {
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to push content for " + _toDisplayString($data.singleContentToPush.product_name) + " " + _toDisplayString($data.singleContentToPush.asin) + " " + _toDisplayString($data.singleContentToPush.sku) + " ? ", 1)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_app_modal, {
    modelValue: $data.confirmPushSelectedContent,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.confirmPushSelectedContent = $event),
    title: "Confirm Push Selected Content",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[17] || (_cache[17] = $event => $options.onPushModalSubmitModifiedContent())
  }, {
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to push the selected content ? ")]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_edit_text_modal, {
    modelValue: $data.editTextModal,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.editTextModal = $event),
    value: $data.editValue,
    original: $data.editOriginal,
    type: $data.type,
    title: $data.title,
    allowHtmlInputAndSpecialCharacters: $options.allowHtmlInputAndSpecialCharacters,
    image: $data.editImage,
    name: $data.editProductName,
    asin: $data.editAsin,
    marketplace_id: _ctx.editMarketplaceId,
    sku: $data.editSku,
    item_highlight: $data.editItemHighlight,
    description: _ctx.editDescription,
    bullet_points: _ctx.editBulletPoints,
    content_id: $data.editContentId,
    show_accept_amazon: $data.showAcceptAmazon,
    children_num: $data.children_num,
    size: "lg",
    show_save_all_children: $data.show_save_all_children,
    parent_asin: $data.editParentAsin,
    onUpdate: $options.onUpdate,
    onSubmit: $options.onSubmit,
    onClose: $options.onCloseEdit,
    onSubmitAllChildren: $options.onSubmitAllChildren
  }, null, 8, ["modelValue", "value", "original", "type", "title", "allowHtmlInputAndSpecialCharacters", "image", "name", "asin", "marketplace_id", "sku", "item_highlight", "description", "bullet_points", "content_id", "show_accept_amazon", "children_num", "show_save_all_children", "parent_asin", "onUpdate", "onSubmit", "onClose", "onSubmitAllChildren"]), _createVNode(_component_image_manager_modal, {
    modelValue: $data.imageManagerModal,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.imageManagerModal = $event),
    image: $data.editImage,
    size: "lg",
    onUpdate: $options.onImageUpdate,
    onSubmit: $options.onImageSubmit
  }, null, 8, ["modelValue", "image", "onUpdate", "onSubmit"])]);
}